import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { Link } from 'src/core-lib/navigation/models/link.model';
import { ContentCache } from 'src/core-lib/navigation/services/content-cache.service';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { IconLink } from '../../models/icon-link.model';
import { Language, Languages, MenuConfiguration } from '../../models/main-configuration.model';




@Component({
    selector: 'app-overlay-menu',
    templateUrl: './overlay-menu.component.html',
    styleUrls: ['./overlay-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayMenuComponent implements OnInit {
    grandparent: Link;
    parent: Link;
    list: Link[];
    @Input() menu: Link[];
    @Input() actions: IconLink[];

    @Input() languages: Languages;
    @Input() currentLanguage: Partial<Language>;
    @Input() user: { name: string };

    @Output() openLoginOverlay: EventEmitter<void> = new EventEmitter<void>();
    @Output() openLanguageOverlay: EventEmitter<void> = new EventEmitter<void>();
    animation: string;
    contentList: Link[];

    constructor(
        private router: Router,
        private overlayService: OverlayService,
        private detector: ChangeDetectorRef,
        private contentCache: ContentCache,
    ) {}

    ngOnInit(): void {
        const menu = this.contentCache.get<MenuConfiguration>('menu');
        this.menu = menu.productMenu;
        this.contentList = menu.contentMenu;
        this.list = this.menu;
    }

    expand(link: Link, direction: 'forward' | 'back' = 'back'): void {
        this.animation = direction;
        setTimeout(() => {
            this.parent = this.findParent(link);
            this.list = link?.children || this.menu;
            this.detector.detectChanges();
            setTimeout(() => {
                this.animation = '';
                this.detector.detectChanges();

            }, 600);
        }, 600);
    }

    navigateOrExpand(link: Link): void {
        if (link?.children?.length > 0) {
            this.expand(link,);
        } else {
            this.navigate(link);
        }
    }

    navigate(link: Link): void {
        this.overlayService.close();
        this.router.navigateByUrl(link.link);
    }

    closeOverLay() {
        this.overlayService.close();
    }

    findParent(linkSearchedFor: Link, parentLink?: Link): Link {
        let found = (parentLink?.children || this.menu).find(link => link === linkSearchedFor);
        if (Guard.not.nullOrEmpty(found)) {
            this.grandparent = parentLink;
            return found;
        } else if (Guard.is.nullOrEmpty(parentLink)) {
            this.menu.some(link => {
                found = this.findParent(linkSearchedFor, link);
                return Guard.not.nullOrEmpty(found);
            });
            return found;
        } else if (parentLink?.children?.length > 0) {
            parentLink?.children.some(link => {
                found = this.findParent(linkSearchedFor, link);
                return Guard.not.nullOrEmpty(found);
            });
            return found;
        } else {
            return null;
        }
    }
}
